import { render } from "./GuidePopup.vue?vue&type=template&id=46f35e52&scoped=true"
import script from "./GuidePopup.vue?vue&type=script&lang=js"
export * from "./GuidePopup.vue?vue&type=script&lang=js"

import "./GuidePopup.vue?vue&type=style&index=0&id=46f35e52&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f35e52"]])

export default __exports__